import { SketchToolEnum } from "../../models";

export enum SketchActions {
  STARTED = "SKETCH_STARTED",
  ENDED = "SKETCH_ENDED",
  TOOL_CHANGED = "SKETCH_TOOL_CHANGED",
}

export interface SketchRequest {
  type: SketchActions.STARTED;
  payload: string;
}
export interface SketchEnded {
  type: SketchActions.ENDED;
}
export interface SketchToolChanged {
  type: SketchActions.TOOL_CHANGED;
  payload: SketchToolEnum;
}

export const dispatchSketchRequest =
  (payload: string) => (dispatch, _getState) => {
    return dispatch({ type: SketchActions.STARTED, payload } as SketchRequest);
  };
export const dispatchSketchEnded = () => (dispatch, _getState) => {
  return dispatch({ type: SketchActions.ENDED } as SketchEnded);
};
export const dispatchSketchToolChanged =
  (payload: SketchToolEnum) => (dispatch, _getState) => {
    return dispatch({
      type: SketchActions.TOOL_CHANGED,
      payload,
    } as SketchToolChanged);
  };
